import { Box, Colors, Text, IcAccount } from 'basic-ui-lib';
// import { useGetCustomerDetail } from 'modules/setting/hooks/useGetCustomerDetail';
import styled from 'styled-components';

const ProfileSection = () => {
  // const [customer] = useGetCustomerDetail(storage.customer_id.get());

  const customer = {
    name: 'Nguyễn Văn A',
    phone: '0123456789',
    avatar: '',
  };
  return (
    <Container>
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          backgroundColor={Colors.primary[5]}
          borderRadius='50%'
          width={120}
          height={120}
        >
          {customer?.avatar ? (
            <img src={customer?.avatar} alt='avatar' className='avatar' />
          ) : (
            <IcAccount width={64} height={64} fill={Colors.neutral.bg[1]} />
          )}
        </Box>
          <Text content_2 medium>
            {customer?.name}
          </Text>
    </Container>
  );
};

export default ProfileSection;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
